import { render, staticRenderFns } from "./BusinessCard.vue?vue&type=template&id=67a7bc1e&scoped=true"
import script from "./BusinessCard.vue?vue&type=script&lang=js"
export * from "./BusinessCard.vue?vue&type=script&lang=js"
import style0 from "./BusinessCard.vue?vue&type=style&index=0&id=67a7bc1e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a7bc1e",
  null
  
)

export default component.exports